  <div class="card-header">
  <app-breadcrumb currentPage="het is gelukt, bedankt!"></app-breadcrumb>
</div>
<div class="card-body">
  <h2>betaling succesvol</h2>
  <p>bedankt, uw betaling was succesvol. U kunt nu uw rapportages definitief maken ter indiening bij de rechtbank</p>

  <div class="btn btn-left"
       [ngClass]="reportInfo.type"
       *ngIf="reportInfo"
       (click)="toReport()">
    ga terug naar de {{ reportService.getReportName(this.reportInfo.type) }}
  </div>

  <div class="spacer"></div>
  <span style="font-size: 130px; line-height: 100%">😀</span>
</div>
